// extracted by mini-css-extract-plugin
export default {"card":"KnownForCard_card__K+HV+"};